var map = {
	"./Train.svg": 360,
	"./area.svg": 361,
	"./btn_add.svg": 362,
	"./btn_add_patient.svg": 241,
	"./btn_back.svg": 363,
	"./btn_delete_patient.svg": 242,
	"./btn_delete_patient_done.svg": 243,
	"./doctor.svg": 364,
	"./fan.svg": 365,
	"./hand.svg": 366,
	"./icon_add_patient.svg": 244,
	"./icon_add_patient_checkbox.svg": 245,
	"./icon_add_patient_checkbox_select.svg": 246,
	"./icon_calendar.svg": 247,
	"./icon_card_normal.svg": 367,
	"./icon_card_selected.svg": 368,
	"./icon_close.svg": 369,
	"./icon_close_popup.svg": 172,
	"./icon_code_finish.svg": 175,
	"./icon_delete_patient.svg": 248,
	"./icon_delete_patient_select.svg": 249,
	"./icon_delete_time.svg": 151,
	"./icon_delete_time_select.svg": 152,
	"./icon_edit.svg": 370,
	"./icon_edit_new.svg": 176,
	"./icon_edit_selected.svg": 371,
	"./icon_edit_white.svg": 250,
	"./icon_explain.svg": 238,
	"./icon_gender_select.svg": 251,
	"./icon_group_checkbox_select.svg": 153,
	"./icon_inconformity.svg": 118,
	"./icon_list_normal.svg": 372,
	"./icon_list_selected.svg": 373,
	"./icon_more.svg": 252,
	"./icon_qr_code 2.svg": 374,
	"./icon_qr_code.svg": 253,
	"./icon_qr_code_selected.svg": 254,
	"./icon_tips.svg": 255,
	"./icon_tips_red.svg": 96,
	"./img_accept.svg": 256,
	"./img_card_1.svg": 375,
	"./img_card_2.svg": 376,
	"./img_card_3.svg": 377,
	"./img_doctor_null.svg": 177,
	"./img_female.svg": 378,
	"./img_finish.svg": 257,
	"./img_follow_up_null.svg": 258,
	"./img_group_null.svg": 379,
	"./img_head_null.svg": 239,
	"./img_male.svg": 380,
	"./img_patient_null.svg": 381,
	"./img_personal.svg": 259,
	"./img_personal_bg.svg": 260,
	"./img_refuse.svg": 261,
	"./img_time_null.svg": 262,
	"./mark.svg": 382,
	"./pc_icon_add_patient.svg": 383,
	"./pc_icon_close.svg": 384,
	"./pc_icon_code_finish.svg": 385,
	"./pc_icon_download.svg": 386,
	"./pc_icon_e_follow_hover.svg": 387,
	"./pc_icon_e_follow_normal.svg": 388,
	"./pc_icon_import.svg": 389,
	"./pc_icon_left_disable.svg": 390,
	"./pc_icon_left_normal.svg": 227,
	"./pc_icon_more.svg": 391,
	"./pc_icon_qr_code.svg": 392,
	"./pc_icon_qr_code_hover.svg": 393,
	"./pc_icon_qr_code_normal.svg": 394,
	"./pc_icon_right_disable.svg": 395,
	"./pc_icon_right_normal.svg": 228,
	"./pinfo.svg": 263,
	"./report.svg": 264,
	"./yao.svg": 396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;